import { ChakraProvider } from '@chakra-ui/react';
import NoticeProvider from 'providers/NoticeProvider';
import { useState } from 'react';
import { Provider } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import { store } from 'store/store';
import AdminLayout from './layouts/admin';
import AuthLayout from './layouts/auth';
import initialTheme from './theme/theme';
import { MAIN_URL } from 'routes';

export default function Main() {
    const [currentTheme, setCurrentTheme] = useState(initialTheme);

    return (
        <Provider store={store}>
            <ChakraProvider theme={currentTheme}>
                <NoticeProvider>
                    <Routes>
                        <Route
                            path="admin/*"
                            element={<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />}
                        />
                        <Route path="auth/*" element={<AuthLayout />} />
                        <Route path="*" element={<Navigate to={MAIN_URL} replace />} />
                    </Routes>
                </NoticeProvider>
            </ChakraProvider>
        </Provider>
    );
}
